<template>
  <Modal v-model="model" sticky reset-drag-position title="编辑下拉框数据" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="edit_select_data">
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:10%;">序号</th>
            <th class="font_style_set" style="width:30%;">字典值</th>
            <th class="font_style_set" v-if="dictType != 'orderState'" style="width:40%;">字典备注</th>
            <th class="font_style_set" v-if="dictType == 'orderState'" style="width:20%;">字典缩略值</th>
            <th class="font_style_set" v-if="dictType == 'orderState'" style="width:20%;">缩略值背景色</th>
            <th class="font_style_set" style="width:20%;border-right: 0px">操作</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" style="max-height: 380px">
        <table class="table_head_footer">
          <tr v-for="(item , index) in dictList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  style="width:10%;">{{index+1}}</td>
            <td  style="width:30%;"><Input placeholder="请输入字典值" style="padding-right:45px" v-model="item.dictValue" :readonly="item.id <0 " maxlength="50" show-word-limit class="dict_input" ref="dictValue" name="dictValue" @change="modifyDictValue(index)"/></td>
            <td  style="width:40%;" v-if="dictType != 'orderState'"><Input placeholder="请输入字典备注" style="padding-right:45px" maxlength="50" show-word-limit v-model="item.dictDescr" :readonly="item.id <0 " class="dict_input" ref="dictDescr" name="dictDescr" @change="modifyDictDescr(index)"/></td>
            <td  style="width:20%;" v-if="dictType == 'orderState'"><input placeholder="请输入字典缩略值" maxlength="1" :value="item.dictDescr.shortValue" :readonly="item.id <0 " class="dict_input" ref="shortValue" @change="modifyShortValue(index)"
                /></td>
            <td  style="width:20%;" v-if="dictType == 'orderState'"><ColorPicker :value="item.dictDescr.color+''" :readonly="item.id <0" @on-change="((val)=>{modifyColor(index,val)})" recommend/></td>
            <td class="template_table_btn" style="width:20%;" v-if="item.id>=0"><span class="search_btn" @click="deleteDict(item.id,index)">删除</span></td>
            <td class="template_table_btn" style="width:20%;" v-if="item.isClose == '0' && item.id<0"><span class="search_btn" :class="{ 'notClick' : item.id == '-10'||item.id == '-11' || item.id == '-27'}" @click="item.id != '-10' &&　item.id != '-11' && item.id != '-27' && btnDisable(item.id,index)">启用</span></td>
             <td class="template_table_btn" style="width:20%;" v-if="item.isClose == '1' && item.id<0"><span class="search_btn" :class="{ 'notClick' : item.id == '-10'||item.id == '-11'||item.id == '-27'}" @click="item.id != '-10' &&　item.id != '-11' && item.id != '-27' && btnEnable(item.id,index)">禁用</span></td>
          </tr>
        </table>
      </div>
    </div>
    <Divider orientation="center"><Button type="info" @click="addSelectData">添加</Button></Divider>
    <div class="btn_template" style="margin-top: 24px;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" :disabled="saveDisabled" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "EditSelectDataDictPop",
        mixins:[publicFunClass],
        props: {
          showDataDictEdit:Boolean,
          dictCode:String,
          moduleId:String,
          dictIsUse:String,
          dictType:String,
        },
        data(){
          return {
            model:false,
            code:'',
            spinShow:true,
            saveDisabled:false,
            dictList:[],
            addData:require('../../assets/image/addData.png'),
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            color:"",
            questionMark:require('../../assets/image/homeAsk.png'),
          }
        },
        methods:{
          modifyDictValue:function(index){
            let name=this.$refs.dictValue[index].name;
            let value=this.$refs.dictValue[index].value;
            this.dictList[index][name]=value;
          },
          modifyDictDescr:function(index){
            let name=this.$refs.dictDescr[index].name;
            let value=this.$refs.dictDescr[index].value;
            this.dictList[index][name]=value;
          },
          modifyShortValue:function(index){
            let value=this.$refs.shortValue[index].value;
            this.dictList[index].dictDescr.shortValue = value;
          },
          modifyColor:function(index,colorValue){
            this.dictList[index].dictDescr.color = colorValue;
          },
          btnDisable:function(id,index){//此时的值为禁用0  点击了启用1  传1
            // if(id=="-7"||id=="-8"){
            //   return false;
            // }else {
              this.dictList[index].isClose= '1';
            // }

          },
          btnEnable:function(id,index){//此时的值为启用1 点击了禁用 传0
          // -7，-8为微信咨询和网页咨询，可以禁用，回显正常
            // if(id=="-7"||id=="-8"){
            //    return false;
            // }else{
              this.dictList[index].isClose= '0';
            // }
          },
          addSelectData:function(){
            let param;
            if(this.dictType == 'orderState'){
                param={
                  id:"",
                  dictCode:this.dictCode,
                  dictValue:"",
                  dictDescr:"{\"color\":\"#000000\",\"shortValue\":\"\"}",
                };
            }else{
                param={
                  id:"",
                  dictCode:this.dictCode,
                  dictValue:"",
                  dictDescr:"",
                  // color:"",
                };
            }

            this.dictList.push(param);
          },
          cancel:function(){
            this.$emit("closeDataDictPop",false);
          },
          save:function () {
            for (let i=1;i<this.dictList.length;i++){
                let dictValue=this.dictList[i].dictValue;
                if(this.dictType == 'orderState'){
                  if(this.dictList[i].dictDescr.shortValue.length > 1){
                    this.$Modal.info({
                      title:'提示',
                      content:"序号"+(i+1)+"的字典缩略值最多仅支持1个字符"
                    });
                    return false;
                  }
                  if(!this.dictList[i].dictDescr.color){
                    this.$Modal.info({
                      title:'提示',
                      content:"序号"+(i+1)+"的缩略值背景色不能为空"
                    });
                    return false;
                  }
                }
                if(!dictValue){
                  this.$Modal.info({
                    title:'提示',
                    content:"序号"+(i+1)+"的字典值不能为空"
                  });
                  return false;
                }
              if(dictValue.length>50){
                this.$Message.info("序号"+(i+1)+"字典值最多仅支持50个字符");
                return false;
              }
              let dictId = this.dictList[i].id;
              // 判断字典值是否已存在
              if(dictId){  // 与已有字典值进行比较
                let dictIndex = this.dictList.findIndex(item => (item.dictValue == dictValue && item.id != dictId));
                if( dictIndex > -1){
                  this.$Message.info("字典值["+dictValue+"]已存在");
                  return false;
                }
              }else{
                // 新添加字典值比较
                let dictIndex = this.dictList.findIndex(item => (item.dictValue == dictValue));
                if( dictIndex > -1 && i != dictIndex){
                  this.$Message.info("字典值["+dictValue+"]已存在");
                  return false;
                }
              }
            }
            let that=this;
            //为工单状态时，对字典值进行处理
            if(this.dictType == "orderState"){
              this.dictList.forEach(function(item, index) {
                if(Object.prototype.toString.call(item.dictDescr) != '[object String]'){
                  that.dictList[index].dictDescr = JSON.stringify(item.dictDescr);
                }
              });
            }
            let param={
               dictList:JSON.stringify(this.dictList),
               moduleId:this.moduleId,
               journalType:"系统管理=>自定义设置=>编辑自定义字典值",
               menuId:"3_2-4"
            };

            this.saveDisabled=true;
            that.$http.post("custom/dict/update-dict.json",param) .then(function (res) {
              let result=res.data.flag;
              that.saveDisabled=false;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("保存成功");
              that.getDictValue(that.dictCode);
            });
          },
          deleteDict:function (id,index) {
            if(!id){
              this.dictList.splice(index,1);
              // this.$Message.info("已删除");
              return false;
            }
            let that=this;
            let param={
              id:id,
              journalType:"系统管理=>自定义设置=>删除自定义字典值",
              menuId:"null"
            };
            let content="删除后将无法恢复,是否确定删除";
            if(this.dictIsUse=='1'){
              content="该下拉框正在使用,删除后将无法恢复,是否确定删除";
            }
            this.$Modal.confirm({
              title: '提示',
              content: content,
              onOk: () => {
                that.$http.post("custom/dict/delete-dict.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.getDictValue(that.code);
                });
              }
            });
          }
        },
        watch:{
          showDataDictEdit:function () {
            this.model=this.showDataDictEdit;
            this.saveDisabled=false;
            this.code=this.dictCode;
            if(this.showDataDictEdit){
              this.spinShow=false;
              this.getDictValue(this.dictCode);
            }else{
              this.dictList.length = 0;
            }
          },
          dictList:function(){
            if(this.dictType == "orderState"){ //为工单状态时，对字典值进行处理
              let that = this;
              this.dictList.forEach(function(item, index) {
                if(Object.prototype.toString.call(item.dictDescr) == '[object String]'){
                  that.dictList[index].dictDescr = JSON.parse(item.dictDescr);
                }
              });
            }
          }
        }
    }
</script>

<style scoped>
.notClick{
  color: #C0C4CC !important;
  cursor: not-allowed !important;
}
.dict_input /deep/ .ivu-input-word-count{
  background: #ffffff00 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/EditSelectDataDictPop.vue